import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as uiActions from '../redux/actions/UI';

// import ReactGA from 'react-ga';

import Loader from '../components/Loader';
import PreloadLink from '../components/PreloadLink';

import { withRouter } from 'react-router-dom';

import classNames from 'classnames';
//import TWEEN from '@tweenjs/tween.js'

function mapStateToProps(state) {
  return {
    menuOpen: state.UI.menuOpen,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showNav: bindActionCreators(uiActions.showNav, dispatch),
    hideNav: bindActionCreators(uiActions.hideNav, dispatch),
    setTemplate: bindActionCreators(uiActions.setTemplate, dispatch),
  };
}

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animPos: 1,
      headerScrolled: false,
      lastScrollPos: 0,
      navOpen: false,
    };
  }

  handleScroll = (e) => {
    const scrollPos = window.scrollY;
    if (scrollPos <= 0) {
      this.setState({ headerScrolled: false });
      return;
    }
    if (scrollPos > this.state.lastScrollPos && scrollPos > 0) {
      // Scrolling down
      this.setState({ headerScrolled: true });
    } else {
      // Scrolling up
      this.setState({ headerScrolled: false });
    }
    this.setState({ lastScrollPos: scrollPos });
  };

  componentDidMount() {
    //this.props.fetchNavigation()
    this.initTemplate();

    this.doAnim();

    this.initGA4();

    window.addEventListener('scroll', this.handleScroll);

    // ReactGA.initialize("UA-48478732-1");
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  toggleNav = () => {
    this.setState({
      navOpen: !this.state.navOpen,
    });
  };

  /*
  <script async src=https://www.googletagmanager.com/gtag/js?id=G-Y03GCTRMVS></script>
<script>
   window.dataLayer = window.dataLayer || [];
   function gtag(){dataLayer.push(arguments);}
   gtag('js', new Date());
 
  gtag('config', 'G-Y03GCTRMVS');
</script>
*/

  initGA4 = () => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-Y03GCTRMVS';
    script.async = true;

    document.body.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config', 'G-Y03GCTRMVS');
  };

  // toggleNav = () => {
  //   if (this.props.menuOpen) {
  //     this.props.hideNav();
  //   } else this.props.showNav();
  // };

  hideNav = () => {
    this.setState({
      navOpen: false,
    });
  };

  initTemplate = () => {
    let path = this.props.location.pathname;
    //console.log(path)

    let template = '';

    switch (path) {
      case '/':
        template = 'home';
        break;
      case '/projects':
        template = 'home';
        break;
      case '/projects/':
        template = 'home';
        break;
      case '/information':
        template = 'page';
        break;
      default:
        template = 'project';
        break;
    }

    this.props.setTemplate(template);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      //setTimeout(() => {
      // ReactGA.pageview(window.location.pathname + window.location.search);
      this.initTemplate();
      //},1000)

      // set template based on pathname

      /*const scroll = {
        top: window.scrollY
      }
      
      let tween = new TWEEN.Tween(scroll)
                        .to({top: 0},750)
                        .easing(TWEEN.Easing.Quadratic.Out)
                        .onUpdate(function() { // Called after tween.js updates 'coords'.
                            console.log(scroll.top)
                            window.scrollTo(0, scroll.top);
                        })
                        .start()

      function animate() {
        requestAnimationFrame(animate);
        TWEEN.update();
      }

      animate()*/
    }
  }

  animTimer = 0;
  stopAnim = false;
  animTimeout = false;
  stopAnimTimeout = false;
  isAnimating = false;

  doAnim = () => {
    const _this = this;

    this.animTimeout = setTimeout(() => {
      _this.animateMenu(true);
      //console.log('animating menu')
      _this.stopAnimTimeout = setTimeout(() => {
        _this.animateMenu(false);
        _this.doAnim();
      }, 24 * 40);
    }, 10000);
  };

  animateMenu = (on) => {
    let _this = this;
    if (on) {
      this.stopAnim = false;
      if (this.isAnimating) clearInterval(this.animTimer);
      //console.log('clearing animTimeout')
      clearTimeout(this.animTimeout);
      clearTimeout(this.stopAnimTimeout);
      this.isAnimating = true;
      //clearInterval(_this.animTimer)
      this.animTimer = setInterval(() => {
        let n = this.state.animPos + 1;
        //console.log(n)
        if (n > 23) {
          if (_this.stopAnim) {
            clearInterval(_this.animTimer);
            _this.stopAnim = false;
            this.isAnimating = false;
            _this.doAnim();
          }
          n = 1;
        }
        _this.setState({
          animPos: n,
        });
      }, 40);
    } else {
      this.stopAnim = true;
    }
  };

  render() {
    // const { menuOpen } = this.props;

    // let toggleClass = classNames(
    //   'Site-navigationToggle',
    //   { 'Site-navigationToggle--open': menuOpen },
    //   `anim--${this.state.animPos}`,
    // );
    let headerClass = classNames({
      'is-scrolled': this.state.headerScrolled,
      'is-open': this.state.navOpen,
    });

    const { navOpen } = this.state;

    return (
      <div className="Site-page">
        <header className={headerClass}>
          <h3 onClick={() => this.hideNav()}>
            <PreloadLink to="/">Village Green</PreloadLink>
          </h3>
          <button className="menu-toggle" onClick={this.toggleNav}>
            {navOpen && <img src="/ui/img/x.svg" alt="close" />}
            {!navOpen && <span>Menu</span>}
          </button>
          <ul>
            <li className="hover-link" onClick={() => this.hideNav()}>
              <PreloadLink to="/projects">Projects</PreloadLink>
            </li>
            <li className="hover-link" onClick={() => this.hideNav()}>
              <PreloadLink to="/information">About</PreloadLink>
            </li>
            <li className="hover-link m-only" onClick={() => this.hideNav()}>
              <a href="mailto:seb@villagegreen.studio">Enquiries</a>
            </li>
            <li className="hover-link m-only" onClick={() => this.hideNav()}>
              <a
                href="https://www.instagram.com/villagegreen.studio/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
          {/* <div
            className={toggleClass}
            onClick={(evt) => {
              this.toggleNav();
            }}
            onMouseEnter={() => {
              this.animateMenu(true);
            }}
            onMouseLeave={() => {
              this.animateMenu(false);
            }}
          >
            {!this.props.menuOpen && (
              <PreloadLink to="/information">Info</PreloadLink>
            )}
            {this.props.menuOpen && <PreloadLink to="/">Home</PreloadLink>}
          </div> */}
        </header>

        <Loader path={this.props.location.pathname} />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));



// WEBPACK FOOTER //
// ./src/js/templates/index.js